const requiredVars = [
  'VITE_API_BASE_URL',
  'VITE_COGNITO_USER_POOL_ID',
  'VITE_COGNITO_CLIENT_ID',
  'VITE_COGNITO_REGION',
  'VITE_STAGE',
] as const;

function validateEnv(): void {
  const missing = requiredVars.filter((key) => !import.meta.env[key]);
  if (missing.length > 0) {
    throw new Error(
      `Missing required environment variables: ${missing.join(', ')}. ` +
        'Check your .env file (or .env.development for local development).'
    );
  }
}

validateEnv();

export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
  cognito: {
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
    region: import.meta.env.VITE_COGNITO_REGION,
  },
  stage: import.meta.env.VITE_STAGE,
} as const;
